import React from "react";
// import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import "./brand.css";
import { BrandCarouselSkeleton } from "./SkeletonLoader";

const Brand = ({brands, loading = false}) => {
    const brandItems = Array.isArray(brands?.cell_contents) ? brands.cell_contents : [];

    const toTitleCase = (value) =>
        String(value || "")
            .trim()
            .toLowerCase()
            .replace(/\b[a-z]/g, (letter) => letter.toUpperCase());

    const getBrandName = (item, index) =>
        toTitleCase(item?.name || item?.title || item?.brand_name || item?.brandName || `Brand ${index + 1}`);

    if (loading) {
        return <BrandCarouselSkeleton />;
    }

    if (!brandItems.length) {
        return null;
    }

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }
    function SamplePrevArrow(props) {
        const { className, onClick } = props;

        return (

            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }
   const totalBrands = brandItems.length || 1;
   const desktopSlidesToShow = 8;
   const shouldUseSlider = totalBrands > desktopSlidesToShow;

    const settings = {
        dots: false,
        arrows: true,
        infinite: shouldUseSlider,
        speed: 1000,
        slidesToShow: desktopSlidesToShow,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1599,
                settings: {
                    slidesToShow: totalBrands >= 7 ? 7 : totalBrands,
                },
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: totalBrands >= 6 ? 6 : totalBrands,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: totalBrands >= 5 ? 5 : totalBrands,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: totalBrands >= 4 ? 4 : totalBrands,
                },
            },
            {
                breakpoint: 424,
                settings: {
                    slidesToShow: totalBrands >= 3 ? 3 : totalBrands,
                },
            },
            {
                breakpoint: 359,
                settings: {
                    slidesToShow: totalBrands >= 2 ? 2 : totalBrands,
                },
            },
        ],
    };
    return (
        <section className="brand">
            <div className="container container-lg">
                <div className="section-heading brand-heading">
                    <h5 className="mb-0">{brands?.title || "Shop by Brands"}</h5>
                </div>
                <div className="brand-slider arrow-style-two">
                    {shouldUseSlider ? (
                        <Slider {...settings}>
                            {brandItems.map((item, i) => {
                                const brandName = getBrandName(item, i);

                                return (
                                    <div className="brand-slide" key={i}>
                                        <div className="brand-item">
                                            <img src={item.image} alt={brandName} />
                                            <p>{brandName}</p>
                                        </div>
                                    </div>
                                );
                            })}
                        </Slider>
                    ) : (
                        <div className="brand-list">
                            {brandItems.map((item, i) => {
                                const brandName = getBrandName(item, i);

                                return (
                                    <div className="brand-item" key={i}>
                                        <img src={item.image} alt={brandName} />
                                        <p>{brandName}</p>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
                {/* <div className="home-section-action">
                    <Link
                        to="/shop"
                        className="home-section-action__link brand-view-all"
                    >
                        View All
                    </Link>
                </div> */}
            </div>
        </section>

    )
}

export default Brand
